<template>
  <div>
    <v-row v-for="(mapping, index) in localValue" :key="index" dense align="center">
      <v-col cols="12" md="5">
        <v-autocomplete
          v-model="mapping.key"
          :items="fields"
          label="Champ à renseigner"
          outlined dense clearable
          @change="emitValue"
        />
      </v-col>
      <v-col cols="12" md="6">
        <v-text-field
          v-model="mapping.value"
          label="Valeur ou variable"
          placeholder="[[line||card_id]]"
          outlined dense clearable
          @input="emitValue"
        />
      </v-col>
      <v-col cols="12" md="1" class="text-right">
        <v-btn icon small color="error" title="Supprimer ce champ" @click="remove(index)">
          <v-icon small>mdi-delete-outline</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <v-btn small outlined color="primary" @click="add">
      <v-icon left small>mdi-plus</v-icon>Ajouter un champ
    </v-btn>
  </div>
</template>

<script>
export default {
  name: 'RepartitionOperationFields',
  props: {
    value: { type: Array, default: () => [] },
    fields: { type: Array, default: () => [] },
  },
  computed: {
    localValue() { return this.value },
  },
  methods: {
    add() {
      this.emitValue([...(this.value || []), { key: '', value: '' }])
    },
    remove(index) {
      this.emitValue((this.value || []).filter((item, itemIndex) => itemIndex !== index))
    },
    emitValue(value = this.value) {
      this.$emit('input', value)
    },
  },
}
</script>
